import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ActionPermissionsPage } from '@/areas/settings/OrganizationSettings/pages/RightsManagement/ActionPermissionsPage';
import { canViewAdvancedUserManagement } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/user-management/action-permissions')({
    staticData: {
        access: { permissions: canViewAdvancedUserManagement },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ActionPermissionsPage />;
}
